import { render, staticRenderFns } from "./BatchDownExportExpressPage.vue?vue&type=template&id=351cd793&"
import script from "./BatchDownExportExpressPage.vue?vue&type=script&lang=js&"
export * from "./BatchDownExportExpressPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports